import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';
import { FacebookFailures, GMBFailures } from '@enums/GMBFailures.enum';

/**
 * Returns a user friendly string to be shown on the UI based on
 * the message returned from GMR api and the review site source where it will
 * be shown
 * @param backendMessage The message returned by GMR apy on the error model
 * @param source The source where the review site is being monitored
 */
@Pipe({
  name: 'reviewTargetErrorMessage'
})
export class ReviewTargetErrorMessagePipe implements PipeTransform {
 
  transform(reviewTarget: ReviewTargetModel): string {
    const { source } = reviewTarget;
    const backendMessage = reviewTarget.error?.name;

    switch (source) {
      case 'googleMyBusiness':
        if (backendMessage == GMBFailures.SentAuthFailure || backendMessage == GMBFailures.AuthFailure)
          return 'Reauthenticate your Google Account'
      case 'facebook':
        if (backendMessage == FacebookFailures.AuthFailure || backendMessage == FacebookFailures.SentAuthFailure)
          return 'Reauthenticate your Facebook Account'
      default: return ''
    }
  }

}
